/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GenerateWorkOSAdminPortalLinkResult = {
  /**
   * URL to the WorkOS Admin Portal flow.
   */
  url: string;
};

/** @internal */
export const GenerateWorkOSAdminPortalLinkResult$inboundSchema: z.ZodMiniType<
  GenerateWorkOSAdminPortalLinkResult,
  unknown
> = z.object({
  url: z.string(),
});

export function generateWorkOSAdminPortalLinkResultFromJSON(
  jsonString: string,
): SafeParseResult<GenerateWorkOSAdminPortalLinkResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GenerateWorkOSAdminPortalLinkResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GenerateWorkOSAdminPortalLinkResult' from JSON`,
  );
}
